import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useQuery } from 'react-query';
import { fetchContentFullDashboardData } from '../../api';

export const useContentfulStateData = () => {
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  return contentfulData;
};

export const useContentfulData = (language: string) => {
  return useQuery<any>('contentfulData', () =>
    fetchContentFullDashboardData(language)
  );
};
